import { render, staticRenderFns } from "./AllegatiTableIncarico.vue?vue&type=template&id=42d45862&"
import script from "./AllegatiTableIncarico.vue?vue&type=script&lang=js&"
export * from "./AllegatiTableIncarico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AllegatiTableIncarico.vue"
export default component.exports